<template>
	<screen class="donations-view">
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">Your Giving</h2>
				<div style="color: white">
					<segment-toggle
						:value="toggleValue"
						:options="options"
						@on-change="toggleView"
						name="donationDetails"
					/>
					<div
						v-if="unlinkedAccounts > 0"
						class="alert roundup-row-center"
						@click="showAccounts"
					>
						<i class="fas fa-exclamation-triangle"></i>
						<p style="margin-left: 15px; color: #ff6376">
							Account Connection Error
						</p>
					</div>
				</div>
			</ui-header>
		</template>
		<donation-list v-if="toggleValue === 'Donations'" />
		<transaction-list v-else />
	</screen>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DonationList from './DonationDetails/DonationList'
import TransactionList from './DonationDetails/TransactionList'
import UiHeader from '../../ui/Header'
import Screen from '../../ui/Screen'
import SegmentToggle from '../../ui/SegmentToggle.vue'

export default {
	name: 'roundup-view',
	components: {
		Screen,
		UiHeader,
		SegmentToggle,
		DonationList,
		TransactionList
	},
	data() {
		return {
			toggleValue: 'RoundUps',
			options: ['RoundUps', 'Donations']
		}
	},
	computed: {
		...mapGetters(['unlinkedAccounts'])
	},
	methods: {
		...mapActions(['getRoundups', 'getTransactions', 'getNotifications']),
		onBack() {
			this.navigate({ name: 'home' }, 'back')
		},
		toggleView() {
			switch (this.toggleValue) {
				case 'RoundUps':
					this.toggleValue = 'Donations'
					break
				default:
					this.toggleValue = 'RoundUps'
			}
		},
		showAccounts() {
			this.navigate({ name: 'accounts' }, 'forward')
		}
	},
	mounted() {
		this.getTransactions()
		this.getNotifications()
		this.getRoundups()
	}
}
</script>

<style lang="scss">
.donations-view {
	background: $bone !important;
	overflow: hidden;
	position: relative;
	.donations-items {
		background: $white;
		margin: 10px -25px 0px;
		position: relative;
		padding: 10px 20px 20px;
		z-index: 10;
		border-radius: 14px;
		box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.15);
		@media screen and (max-width: 480px) {
			margin-left: -15px;
			margin-right: -15px;
		}
		.donation-item {
			padding: 20px 10px;
			border-bottom: 1px solid $light-grey;
			cursor: pointer;
			text-decoration: none;
			color: $blue;
			&:last-child {
				border-bottom: 0px;
			}
			.date {
				flex-grow: 1;
				color: #111;
			}
			.amount {
				flex-grow: 0;
			}
			.error {
				color: $red;
				display: flex;
				flex: 1;
				.date {
					color: $red;
				}
			}
			.no-error {
				display: flex;
				flex: 1;
			}
			p {
				text-align: center;
				padding: 0;
				margin: 0;
			}
		}
		.settings-section {
			margin-bottom: 20px;
		}
	}
	.roundup-row-center {
		flex-direction: row;
		display: flex;
		align-items: center;
	}
	.alert {
		color: $red;
		margin: 15px;
		margin-left: 0px;
		justify-content: center;
		align-items: center;
		width: 100%;
		display: flex;
		cursor: pointer;
		p {
			margin: 0;
		}
	}
}
</style>
